<template>
  <div v-if="formData" class="fin-form solid-table">
    <div class="fin-form-content transtant-input">
      <el-form
        size="mini"
        :inline="true"
        ref="form"
        :model="formData"
        :rules="rules"
        label-suffix="："
      >
        <el-collapse v-model="collapseModel">
          <el-collapse-item title="关键指标" name="important">
            <el-form-item
              label="运营期（年）"
              prop="operatingPeriod"
              ref="operatingPeriod"
              :rules="rules.operatingPeriod"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.operatingPeriod"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="建设期（年）"
              prop="constructionPeriod"
              ref="constructionPeriod"
              :rules="rules.constructionPeriod"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.constructionPeriod"
              ></el-input>
            </el-form-item>
            <el-form-item label="装机容量（MW）" prop="cap" ref="cap">
              <div style="display: flex;">
                <el-input
                  placeholder="请输入"
                  v-model="formData.cap"
                ></el-input>
                <el-button
                  icon="el-icon-refresh-left"
                  title="获取风场装机容量"
                  @click="resetParam('cap', 'windfarmCap')"
                  circle
                ></el-button>
              </div>
            </el-form-item>

            <el-form-item
              label="静态总投资（万元）"
              prop="staticTotalInvestment"
              ref="staticTotalInvestment"
            >
              <div style="display: flex;">
                <el-input
                  placeholder="请输入"
                  v-model="formData.staticTotalInvestment"
                ></el-input>
                <el-button
                  icon="el-icon-refresh-left"
                  title="获取风场静态总投资"
                  @click="
                    resetParam(
                      'staticTotalInvestment',
                      'windfarmStaticTotalInvestment'
                    )
                  "
                  circle
                ></el-button>
              </div>
            </el-form-item>
            <el-form-item
              label="资本金比例（%）"
              prop="capitalRate"
              ref="capitalRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.capitalRate"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="长期贷款利率（%）"
              prop="loanInterestRate"
              ref="loanInterestRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.loanInterestRate"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="满发小时数（h）"
              prop="equivalentHour"
              ref="equivalentHour"
            >
              <div style="display: flex;">
                <el-input
                  placeholder="请输入"
                  v-model="formData.equivalentHour"
                ></el-input>
                <el-button
                  icon="el-icon-refresh-left"
                  title="获取风场静态总投资"
                  @click="
                    resetParam('equivalentHour', 'windfarmEquivalentHour')
                  "
                  circle
                ></el-button>
              </div>
            </el-form-item>
            <el-form-item
              label="含税电价（元/kwh）"
              prop="priceWith"
              ref="priceWith"
            >
              <e-price v-model="formData.priceWith"></e-price>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item title="基本参数" name="basic">
            <el-divider content-position="left">年限和装机容量</el-divider>
            <el-form-item
              label="运营期（年）"
              prop="operatingPeriod"
              ref="operatingPeriod"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.operatingPeriod"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="建设期（年）"
              prop="constructionPeriod"
              ref="constructionPeriod"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.constructionPeriod"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="开工年份"
              prop="constructionStarttime"
              ref="constructionStarttime"
            >
              <el-date-picker
                v-model="formData.constructionStarttime"
                type="month"
                style="width:200px"
                placeholder="请输入开工年份"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="装机容量（MW）" prop="cap">
              <div style="display: flex;">
                <el-input
                  placeholder="请输入"
                  v-model="formData.cap"
                ></el-input>
                <el-button
                  icon="el-icon-refresh-left"
                  title="获取风场装机容量"
                  @click="resetParam('cap', 'windfarmCap')"
                  circle
                ></el-button>
              </div>
            </el-form-item>

            <el-divider content-position="left">建设期分年度投资</el-divider>
            <el-form-item
              label="静态总投资（万元）"
              prop="staticTotalInvestment"
            >
              <div style="display: flex;">
                <el-input
                  placeholder="请输入"
                  v-model="formData.staticTotalInvestment"
                ></el-input>
                <el-button
                  icon="el-icon-refresh-left"
                  title="获取风场静态总投资"
                  @click="
                    resetParam(
                      'staticTotalInvestment',
                      'windfarmStaticTotalInvestment'
                    )
                  "
                  circle
                ></el-button>
              </div>
            </el-form-item>
            <cap-year-input
              v-model="formData.constructionInvest"
              label="分年度投资（万元）"
              prop="constructionInvest"
              ref="constructionInvest"
              :base="1"
              :cap="+formData.staticTotalInvestment"
              :count="constructionPeriodCount"
              :rules="rules.constructionInvest"
            />
            <el-form-item
              label="可抵扣增值税比例（%）"
              prop="vatRate"
              ref="vatRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.vatRate"
              ></el-input>
            </el-form-item>
            <multi-input
              v-model="formData.immaterialAssets"
              prop="immaterialAssets"
              ref="immaterialAssets"
              :rules="rules.immaterialAssets"
              label="无形资产（万元）"
              defaultValue="0"
              :count="constructionPeriodCount"
            >
            </multi-input>
            <multi-input
              v-model="formData.otherAssets"
              prop="otherAssets"
              ref="otherAssets"
              :rules="rules.otherAssets"
              label="其他资产（万元）"
              defaultValue="0"
              :count="constructionPeriodCount"
            >
            </multi-input>

            <el-divider content-position="left">资本金投入</el-divider>
            <el-form-item
              label="资本金比例（%）"
              prop="capitalRate"
              ref="capitalRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.capitalRate"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="资本金基准收益率-贴现率（%）"
              prop="marr"
              ref="marr"
            >
              <el-input placeholder="请输入" v-model="formData.marr"></el-input>
            </el-form-item>
            <el-form-item
              label="行业基准收益率（所得税前）（%）"
              prop="marrBeforeTax"
              ref="marrBeforeTax"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.marrBeforeTax"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="行业基准收益率（所得税后）（%）"
              prop="marrAfterTax"
              ref="marrAfterTax"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.marrAfterTax"
              ></el-input>
            </el-form-item>

            <el-divider content-position="left">流动资金及短期贷款</el-divider>
            <el-form-item
              label="单位千瓦流动资金（元/kw）"
              prop="fluidUnit"
              ref="fluidUnit"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.fluidUnit"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="流动资金贷款比例（%）"
              prop="fluidLoanRatio"
              ref="fluidLoanRatio"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.fluidLoanRatio"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="流动资金贷款利率（%）"
              prop="fluidLoanRate"
              ref="fluidLoanRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.fluidLoanRate"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="短期贷款利率（%）"
              prop="shortLoanRate"
              ref="shortLoanRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.shortLoanRate"
              ></el-input>
            </el-form-item>

            <el-divider content-position="left">长期借款利息</el-divider>
            <el-form-item
              label="贷款年限（年）"
              prop="repaymentPeriod"
              ref="repaymentPeriod"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.repaymentPeriod"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="还款类型（%）"
              prop="repayType"
              ref="repayType"
            >
              <el-select
                placeholder="请选择还款类型"
                v-model="formData.repayType"
              >
                <el-option label="等额本息" :value="0"></el-option>
                <el-option label="等额本金" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="长期贷款利率（%）"
              prop="loanInterestRate"
              ref="loanInterestRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.loanInterestRate"
              ></el-input>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item title="成本费用" name="cost">
            <el-divider content-position="left">折旧费</el-divider>
            <el-form-item label="残值率（%）" prop="salvage" ref="salvage">
              <el-input
                placeholder="请输入"
                v-model="formData.salvage"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="折旧数据类型"
              prop="depreciableType"
              ref="depreciableType"
            >
              <el-select
                placeholder="请选择折旧数据类型"
                v-model="formData.depreciableType"
              >
                <el-option label="折旧年限" :value="0"></el-option>
                <el-option label="综合折旧率" :value="1"></el-option>
                <el-option label="手动输入折旧费" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <type-input
              :labels="['折旧年限（年）', '综合折旧率（%）', '折旧费（万元）']"
              :types="['depreciableYears', 'depreciableRate', 'depreciableFee']"
              :type="formData.depreciableType"
              :multiple="+formData.depreciableType === 2"
              :formData="formData"
              :rules="rules"
              :count="operatingPeriodCount + constructionPeriodCount"
            />

            <el-divider content-position="left">维修费</el-divider>
            <el-form-item
              label="维修数据单位"
              prop="maintainType"
              ref="maintainType"
            >
              <el-select
                placeholder="请选择维修数据单位"
                :disabled="backend"
                v-model="formData.maintainType"
              >
                <el-option label="%" :value="0"></el-option>
                <el-option label="元/kw" :value="1"></el-option>
                <el-option label="万元" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="数据维数" prop="maintainNum" ref="maintainNum">
              <el-select
                placeholder="请选择数据维数"
                :disabled="backend"
                v-model="formData.maintainNum"
              >
                <el-option label="各年相同" :value="0"></el-option>
                <el-option label="各年不同" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <type-input
              :labels="['维修费率', '单位维修费', '维修费']"
              :types="['maintainRate', 'unitMaintainFee', 'maintainFee']"
              :type="formData.maintainType"
              :multiple="+formData.maintainNum === 1"
              multiPrefix="diff"
              :formData="formData"
              :rules="rules"
              :count="operatingPeriodCount + constructionPeriodCount"
            />

            <el-divider content-position="left">人工工资及福利</el-divider>
            <el-form-item
              label="人员种类"
              prop="staffTypeNum"
              ref="staffTypeNum"
              :rules="rules.staffTypeNum"
            >
              <el-input v-model="formData.staffTypeNum" placeholder="请输入" />
            </el-form-item>
            <multi-input
              v-model="formData.staffCapacity"
              prop="staffCapacity"
              ref="staffCapacity"
              :rules="rules.staffCapacity"
              label="人员数量"
              unit="种"
              :count="staffTypeNumCount"
            >
            </multi-input>
            <multi-input
              v-model="formData.staffSalary"
              prop="staffSalary"
              ref="staffSalary"
              :rules="rules.staffSalary"
              label="人均年平均工资（万元/年）"
              unit="种"
              :count="staffTypeNumCount"
            >
            </multi-input>
            <multi-input
              v-model="formData.welfareRate"
              prop="welfareRate"
              ref="welfareRate"
              :rules="rules.welfareRate"
              label="福利系数（%）"
              unit="种"
              :count="staffTypeNumCount"
            >
            </multi-input>

            <el-divider content-position="left">保险费</el-divider>
            <el-form-item
              label="保险数据单位"
              prop="insureType"
              ref="insureType"
            >
              <el-select
                placeholder="请选择保险数据单位"
                :disabled="backend"
                v-model="formData.insureType"
              >
                <el-option label="%" :value="0"></el-option>
                <el-option label="元/kw" :value="1"></el-option>
                <el-option label="万元" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保险计算方式" prop="insureNum" ref="insureNum">
              <el-select
                placeholder="请选择保险计算方式"
                :disabled="backend"
                v-model="formData.insureNum"
              >
                <el-option label="各年相同" :value="0"></el-option>
                <el-option label="各年不同" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保险计算基数" prop="insureRaw" ref="insureRaw">
              <el-select
                placeholder="请选择保险计算基数"
                v-model="formData.insureRaw"
              >
                <el-option label="固定资产原值" :value="0"></el-option>
                <el-option label="固定资产净值" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <type-input
              :labels="['保险费率', '单位保险费', '保险费']"
              :types="['insureRate', 'unitInsureFee', 'insureFee']"
              :type="formData.insureType"
              :multiple="+formData.insureNum === 1"
              multiPrefix="diff"
              :formData="formData"
              :rules="rules"
              :count="operatingPeriodCount + constructionPeriodCount"
            />

            <el-divider content-position="left">材料费</el-divider>
            <el-form-item
              label="材料费数据单位"
              prop="materialType"
              ref="materialType"
            >
              <el-select
                placeholder="请选择材料费数据单位"
                :disabled="backend"
                v-model="formData.materialType"
              >
                <el-option label="%" :value="0"></el-option>
                <el-option label="元/kw" :value="1"></el-option>
                <el-option label="万元" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="材料费计算方式"
              prop="materialNum"
              ref="materialNum"
            >
              <el-select
                placeholder="请选择材料费计算方式"
                :disabled="backend"
                v-model="formData.materialNum"
              >
                <el-option label="各年相同" :value="0"></el-option>
                <el-option label="各年不同" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <type-input
              :labels="['材料费率', '单位材料费', '材料费']"
              :types="['insureRate', 'unitInsureFee', 'insureFee']"
              :type="formData.materialType"
              :multiple="+formData.materialNum === 1"
              multiPrefix="diff"
              :formData="formData"
              :rules="rules"
              :count="operatingPeriodCount + constructionPeriodCount"
            />

            <el-divider content-position="left">摊销费</el-divider>
            <el-form-item
              label="无形资产摊销年限（年）"
              prop="immaterialAmortization"
              ref="immaterialAmortization"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.immaterialAmortization"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="其他资产摊销年限（年）"
              prop="otherAmortization"
              ref="otherAmortization"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.otherAmortization"
              ></el-input>
            </el-form-item>

            <el-divider content-position="left">其他费用</el-divider>
            <el-form-item
              label="其他费用计算方式"
              prop="otherFeeNum"
              ref="otherFeeNum"
            >
              <el-select :disabled="backend" v-model="formData.otherFeeNum">
                <el-option label="各年相同" :value="0"></el-option>
                <el-option label="各年不同" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="其他费用1单位"
              prop="otherFeeType1"
              ref="otherFeeType1"
            >
              <el-select
                placeholder="请选择单位"
                :disabled="backend"
                v-model="formData.otherFeeType1"
              >
                <el-option label="元/kw" :value="1"></el-option>
                <el-option label="万元" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <type-input
              :labels="['单位其他费用1', '其他费用1']"
              :types="['unitOtherFee1', 'otherFee1']"
              :type="formData.otherFeeType1 - 1"
              :multiple="+formData.otherFeeNum === 1"
              multiPrefix="diff"
              :formData="formData"
              :rules="rules"
              :count="operatingPeriodCount + constructionPeriodCount"
            />
            <el-form-item
              label="其他费用2单位"
              prop="otherFeeType2"
              ref="otherFeeType2"
            >
              <el-select
                placeholder="请选择单位"
                v-model="formData.otherFeeType2"
              >
                <el-option label="元/kw" :value="1"></el-option>
                <el-option label="万元" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <type-input
              :labels="['单位其他费用2', '其他费用2']"
              :types="['unitOtherFee2', 'otherFee2']"
              :type="formData.otherFeeType2 - 1"
              :multiple="+formData.otherFeeNum === 1"
              multiPrefix="diff"
              :formData="formData"
              :rules="rules"
              :count="operatingPeriodCount + constructionPeriodCount"
            />
          </el-collapse-item>

          <el-collapse-item title="收入和税金" name="income">
            <el-divider content-position="left">产量</el-divider>
            <el-form-item
              label="等效利用小时数（h）"
              prop="equivalentHour"
              ref="equivalentHour"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.equivalentHour"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="上网电量计算方式"
              prop="energyType"
              ref="energyType"
            >
              <el-select
                placeholder="请选择上网电量计算方式"
                v-model="formData.energyType"
              >
                <el-option label="自动计算" :value="0"></el-option>
                <el-option label="手动输入" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <multi-input
              v-model="formData.energyData"
              prop="energyData"
              ref="energyData"
              :defaultValue="1"
              :rules="rules.energyData"
              :label="['发电量系数', '电量数据（kWH）'][formData.energyType]"
              :count="operatingPeriodCount + constructionPeriodCount"
            >
            </multi-input>

            <el-divider content-position="left">装机进度</el-divider>
            <cap-year-input
              v-model="formData.ongridCapacity"
              prop="ongridCapacity"
              ref="ongridCapacity"
              :rules="rules.ongridCapacity"
              label="各年新增装机情况（MW）"
              :cap="+formData.cap"
              :count="constructionPeriodCount"
            >
            </cap-year-input>

            <el-divider content-position="left">税率</el-divider>
            <el-form-item label="增值税率（%）" prop="vat" ref="vat">
              <el-input placeholder="请输入" v-model="formData.vat"></el-input>
            </el-form-item>
            <el-form-item
              label="所得税计算方式"
              prop="incomeTaxType"
              ref="incomeTaxType"
            >
              <el-select
                placeholder="请选择所得税计算方式"
                v-model="formData.incomeTaxType"
              >
                <el-option label="各年相同" :value="0"></el-option>
                <el-option label="各年不同" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <type-input
              :labels="['企业所得税率（%）', '企业所得税率（%）']"
              :types="['incomeTaxRate', 'diffIncomeTaxRate']"
              :type="formData.incomeTaxType"
              :multiple="+formData.incomeTaxType === 1"
              :formData="formData"
              :rules="rules"
              :count="operatingPeriodCount + constructionPeriodCount"
            />

            <el-form-item
              label="城市维护建设费率（%）"
              prop="urbanConstructionTaxRate"
              ref="urbanConstructionTaxRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.urbanConstructionTaxRate"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="教育附加费（%）"
              prop="educationAddRate"
              ref="educationAddRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.educationAddRate"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="增值税即征即退"
              prop="vatPolicy"
              ref="vatPolicy"
            >
              <el-select placeholder="请选择" v-model="formData.vatPolicy">
                <el-option label="无" :value="0"></el-option>
                <el-option label="有" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="所得税N免（年）"
              prop="incomeTaxNexempt"
              ref="incomeTaxNexempt"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.incomeTaxNexempt"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="所得税N减半（年）"
              prop="incomeTaxNhalved"
              ref="incomeTaxNhalved"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.incomeTaxNhalved"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="法定盈余公积金比例（%）"
              prop="proportionSurplusReserve"
              ref="proportionSurplusReserve"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.proportionSurplusReserve"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="任意盈余公积金比例（%）"
              prop="proportionSurplusDiscretionary"
              ref="proportionSurplusDiscretionary"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.proportionSurplusDiscretionary"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="应付利润比例（%）"
              prop="profitPayableRatio"
              ref="profitPayableRatio"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.profitPayableRatio"
              ></el-input>
            </el-form-item>

            <el-divider content-position="left">电价</el-divider>
            <el-form-item label="税类型" prop="taxType" ref="taxType">
              <el-select placeholder="请选择" v-model="formData.taxType">
                <el-option label="所得税" :value="0"></el-option>
                <el-option label="调整所得税" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="含税电价（元/kwh）"
              prop="priceWith"
              ref="priceWith"
            >
              <e-price v-model="formData.priceWith"></e-price>
            </el-form-item>
            <el-form-item
              label="是否分两阶段电价"
              prop="priceType"
              ref="priceType"
            >
              <el-select placeholder="请选择" v-model="formData.priceType">
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第一阶段小时数（h）"
              v-if="+formData.priceType === 1"
              prop="hoursLimit"
              ref="hoursLimit"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.hoursLimit"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="+formData.priceType === 1"
              prop="priceWith2"
              ref="priceWith2"
              label="第二阶段含税电价（元/kwh）"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.priceWith2"
              ></el-input>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="计算LCOE" name="lcoe">
            <el-form-item label="IRR类型" prop="irrType" ref="irrType">
              <el-select
                placeholder="请选择还款类型"
                v-model="formData.irrType"
              >
                <el-option label="项目投资税后收益率" :value="0"></el-option>
                <el-option label="资本金收益率" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="IRR大小" prop="irrData" ref="irrData">
              <el-input
                placeholder="请输入"
                v-model="formData.irrData"
              ></el-input>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="敏感性分析" name="sensitive">
            <el-form-item
              label="是否敏感性分析"
              prop="whetherSense"
              ref="whetherSense"
            >
              <el-select placeholder="请选择" v-model="formData.whetherSense">
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <div v-if="+formData.whetherSense === 1">
              <el-form-item
                label="总投资浮动（%）"
                prop="totalInvestArr"
                ref="totalInvestArr"
              >
                <inputs
                  placeholder="请输入"
                  :count="5"
                  v-model="formData.totalInvestArr"
                >
                </inputs>
              </el-form-item>
              <el-form-item
                label="电量浮动（%）"
                prop="energyDataArr"
                ref="energyDataArr"
              >
                <inputs
                  placeholder="请输入"
                  :count="5"
                  v-model="formData.energyDataArr"
                ></inputs>
              </el-form-item>
              <el-form-item
                label="含税电价浮动（%）"
                prop="priceWithArr"
                ref="priceWithArr"
              >
                <inputs
                  placeholder="请输入"
                  :count="5"
                  v-model="formData.priceWithArr"
                ></inputs>
              </el-form-item>
              <el-form-item
                label="长期贷款利率浮动（%）"
                prop="loanInterestRateArr"
                ref="loanInterestRateArr"
              >
                <inputs
                  placeholder="请输入"
                  :count="5"
                  v-model="formData.loanInterestRateArr"
                ></inputs>
              </el-form-item>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <div class="bottom-tool">
      <el-button @click="reset" v-if="canSave">重置</el-button>
      <el-button type="primary" @click="save" v-if="canSave">{{
        backend ? '保存' : '保存并计算'
      }}</el-button>
    </div>
  </div>
  <div v-else>
    <div class="fin-form empty-form">暂无数据</div>
  </div>
</template>

<script>
import sum from 'lodash/sum';

import { number, checkNumber, convertRule } from '@/utils/rules';
import EPrice from './e-price';
import MultiInput from './multi-input';
import CapYearInput from './cap-year-input';
import Inputs from './inputs';
import TypeInput from './type-input';

export default {
  components: {
    EPrice,
    Inputs,
    MultiInput,
    CapYearInput,
    TypeInput
  },
  props: {
    formData: {
      type: Object,
      default: () => null
    },
    windfarmData: {
      type: Object,
      default: () => null
    },
    backend: {
      type: Boolean,
      default: () => false
    },
    defaultData: {
      type: Object,
      defualt: () => null
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(2000, 0, 1).getTime();
        }
      },
      collapseModel: [
        'relate',
        'important',
        'basic',
        'cost',
        'income',
        'type',
        'lcoe',
        'sensitive'
      ],
      rules: {
        operatingPeriod: [
          number({
            min: 10,
            max: 30,
            equal: { min: true, max: true },
            precision: 0
          })
        ],
        constructionPeriod: [
          number({
            min: 1,
            max: 5,
            equal: { min: true, max: true },
            precision: 0
          })
        ],
        constructionStarttime: [
          { required: true, message: '请输入开工年份', trigger: 'change' }
        ],
        constructionInvest: [
          number({ min: 50, max: 20000000, equal: { min: true, max: true } })
        ],
        cap: [
          number({ min: 0.1, max: 10000, equal: { min: true, max: true } })
        ],
        staticTotalInvestment: [
          number({ min: 20, max: 20000000, equal: { min: true, max: true } })
        ],
        vatRate: [number({ min: 0, max: 30, equal: { min: true, max: true } })],
        immaterialAssets: [
          number({ min: 0, equal: { min: true } }),
          convertRule({
            message: '必须小于分年度投资总和',
            validator: value =>
              value < sum(this.formData.constructionInvest.map(val => +val))
          })
        ],
        otherAssets: [
          number({ min: 0, equal: { min: true } }),
          convertRule({
            message: '必须小于分年度投资总和',
            validator: value =>
              value < sum(this.formData.constructionInvest.map(val => +val))
          })
        ],
        capitalRate: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        marr: [number({ min: 0, max: 20, equal: { min: true, max: true } })],
        marrBeforeTax: [
          number({ min: 0, max: 20, equal: { min: true, max: true } })
        ],
        marrAfterTax: [
          number({ min: 0, max: 20, equal: { min: true, max: true } })
        ],
        fluidUnit: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        fluidLoanRatio: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        fluidLoanRate: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        shortLoanRate: [
          number({ min: 0, max: 20, equal: { min: true, max: true } })
        ],
        repayType: [{ required: true, trigger: 'change' }],
        repaymentPeriod: [
          convertRule({
            required: true,
            message: () => {
              return '请输入1~风场运营期之间的数字';
            },
            validator: value => {
              return checkNumber(value, {
                min: 1,
                max: this.formData.operatingPeriod,
                equal: { min: true, max: true }
              });
            }
          })
        ],
        loanInterestRate: [
          number({ min: 0, max: 20, equal: { min: true, max: true } })
        ],
        salvage: [number({ min: 0, max: 10, equal: { min: true, max: true } })],
        depreciableType: [{ required: true, trigger: 'change' }],
        depreciableYears: [
          number({ min: 5, max: 30, equal: { min: true, max: true } })
        ],
        depreciableRate: [
          number({ min: 4, max: 20, equal: { min: true, max: true } })
        ],
        depreciableFee: [
          convertRule({
            required: true,
            message: '请输入0-分年投资总和的数字',
            validator: value => {
              return checkNumber(value, {
                min: 0,
                max: sum(this.formData.constructionInvest.map(val => +val)),
                equal: { min: true, max: true }
              });
            }
          })
        ],
        maintainType: [{ required: true, trigger: 'change' }],
        maintainNum: [{ required: true, trigger: 'change' }],
        // 'maintainRate', 'unitMaintainFee', 'maintainFee'
        maintainRate: [
          number({ min: 0, max: 20, equal: { min: true, max: true } })
        ],
        unitMaintainFee: [
          number({ min: 0, max: 1000, equal: { min: true, max: true } })
        ],
        maintainFee: [number({ min: 0, equal: { min: true } })],
        staffTypeNum: [
          number({ min: 0, max: 5, equal: { min: true, max: true } })
        ],
        staffCapacity: [
          number({ min: 0, max: 1000, equal: { min: true, max: true } })
        ],
        staffSalary: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        welfareRate: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        insureType: [{ required: true, trigger: 'change' }],
        insureNum: [{ required: true, trigger: 'change' }],
        insureRaw: [{ required: true, trigger: 'change' }],
        insureRate: [
          number({ min: 0, max: 1, equal: { min: true, max: true } })
        ],
        unitInsureFee: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        insureFee: [number({ min: 0, equal: { min: true } })],
        materialType: [{ required: true, trigger: 'change' }],
        materialNum: [{ required: true, trigger: 'change' }],
        materialConsumption: [
          convertRule({
            required: true,
            message: () => {
              const type = +this.formData.materialType;
              if (type === 0) {
                return '请输入0-30之间的数字';
              }
              if (type === 1) {
                return '请输入0-100之间的数字';
              }
              return '请输入大于0的数字';
            },
            validator: value => {
              const type = +this.formData.materialType;
              if (type === 0) {
                return checkNumber(value, {
                  min: 0,
                  max: 30,
                  equal: { min: true, max: true }
                });
              }
              if (type === 1) {
                return checkNumber(value, {
                  min: 0,
                  max: 100,
                  equal: { min: true, max: true }
                });
              }
              return checkNumber(value, {
                min: 0
              });
            }
          })
        ],
        immaterialAmortization: [
          convertRule({
            required: true,
            message: '请输入0-运行期之间的数字',
            validator: value =>
              checkNumber(value, {
                min: 0,
                max: this.formData.operatingPeriod,
                equal: { min: true, max: true }
              })
          })
        ],
        otherAmortization: [
          convertRule({
            required: true,
            message: '请输入0-运行期之间的数字',
            validator: value =>
              checkNumber(value, {
                min: 0,
                max: this.formData.operatingPeriod,
                equal: { min: true, max: true }
              })
          })
        ],
        otherFeeNum: [{ required: true, trigger: 'change' }],
        otherFeeType1: [{ required: true, trigger: 'change' }],
        unitOtherFee1: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        otherFee1: [number({ min: 0, equal: { min: true } })],

        otherFeeType2: [{ required: true, trigger: 'change' }],
        unitOtherFee2: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        otherFee2: [number({ min: 0, equal: { min: true } })],
        energyType: [{ required: true, trigger: 'change' }],
        equivalentHour: [
          number({ min: 0, max: 8760, equal: { min: true, max: true } })
        ],
        energyData: [
          convertRule({
            required: true,
            message: () => {
              const type = +this.formData.energyType;
              if (type === 0) {
                return '请输入大于等于0小于等于2的数字';
              }
              return '请输入大于等于0的数字';
            },
            validator: value => {
              const type = +this.formData.energyType;
              if (type === 0) {
                return checkNumber(value, {
                  min: 0,
                  max: 2,
                  equal: { min: true, max: true }
                });
              }
              return checkNumber(value, {
                min: 0,
                equal: { min: true }
              });
            }
          })
        ],
        ongridCapacity: [
          convertRule({
            required: true,
            message: '请输入0-装机容量之间的数字',
            validator: value =>
              checkNumber(value, {
                min: 0,
                max: this.formData.cap,
                equal: { min: true, max: true }
              })
          })
        ],
        incomeTaxType: [{ required: true, trigger: 'change' }],
        vat: [number({ min: 0, max: 20, equal: { min: true, max: true } })],
        incomeTaxRate: [
          number({ min: 0, max: 50, equal: { min: true, max: true } })
        ],
        diffIncomeTaxRate: [
          number({ min: 0, max: 50, equal: { min: true, max: true } })
        ],
        urbanConstructionTaxRate: [
          number({ min: 0, max: 10, equal: { min: true, max: true } })
        ],
        vatPolicy: [{ required: true, trigger: 'change' }],
        educationAddRate: [
          number({ min: 0, max: 10, equal: { min: true, max: true } })
        ],
        incomeTaxNexempt: [
          number({ min: 0, max: 10, equal: { min: true, max: true } })
        ],
        incomeTaxNhalved: [
          number({ min: 0, max: 10, equal: { min: true, max: true } })
        ],
        proportionSurplusReserve: [
          number({ min: 0, max: 20, equal: { max: true } })
        ],
        proportionSurplusDiscretionary: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        profitPayableRatio: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        taxType: [{ required: true, trigger: 'change' }],
        priceType: [{ required: true, trigger: 'change' }],
        priceWith: [number({ min: 0, max: 10 })],
        priceWith2: [number({ min: 0, max: 10 })],
        hoursLimit: [
          number({ min: 0, max: 8760, equal: { min: true, max: true } })
        ],
        irrType: [{ required: true, trigger: 'change' }],
        irrData: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        whetherSense: [{ required: true, trigger: 'change' }],
        totalInvestArr: [
          convertRule({
            required: false,
            message: '请输入整数'
            // validator: value => {
            //   if (isEmpty(value)) return true;
            //   return isNil(
            //     value.find(
            //       item =>
            //         !checkNumber(item, {
            //           precision: 0
            //         })
            //     )
            //   );
            // }
          })
        ],
        energyDataArr: [
          convertRule({
            required: false,
            message: '请输入整数'
            // validator: value => {
            //   if (isEmpty(value)) return true;
            //   return isNil(
            //     value.find(
            //       item =>
            //         !checkNumber(item, {
            //           precision: 0
            //         })
            //     )
            //   );
            // }
          })
        ],
        priceWithArr: [
          convertRule({
            required: false,
            message: '请输入整数'
            // validator: value => {
            //   if (isEmpty(value)) return true;
            //   return isNil(
            //     value.find(
            //       item =>
            //         !checkNumber(item, {
            //           precision: 0
            //         })
            //     )
            //   );
            // }
          })
        ],
        loanInterestRateArr: [
          convertRule({
            required: false,
            message: '请输入整数'
            // validator: value => {
            //   if (isEmpty(value)) return true;
            //   return isNil(
            //     value.find(
            //       item =>
            //         !checkNumber(item, {
            //           precision: 0
            //         })
            //     )
            //   );
            // }
          })
        ]
      }
    };
  },
  computed: {
    baseValue() {
      return +this.formData?.landOrSea === 1 ? 700 : 1500;
    },
    canSave() {
      return true;
    },
    constructionPeriodCount() {
      const count = +this.formData.constructionPeriod;
      if (window.isNaN(count)) return 1;
      if (count > 5) {
        return 5;
      }
      if (count < 1) {
        return 1;
      }
      return count;
    },
    operatingPeriodCount() {
      const count = +this.formData.operatingPeriod;
      if (window.isNaN(count)) return 1;
      if (count > 30) {
        return 30;
      }
      if (count < 10) {
        return 10;
      }
      return count;
    },
    staffTypeNumCount() {
      const count = +this.formData.staffTypeNum;
      if (window.isNaN(count)) return 1;
      if (count > 5) {
        return 5;
      }
      if (count < 0) {
        return 0;
      }
      return count;
    }
  },
  methods: {
    save() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.$emit('save');
        } else {
          for (let i in object) {
            let dom = this.$refs[i];
            if (i.indexOf('.') !== -1) {
              dom = this.$refs[i.split('.')[0]];
            }
            if (
              Object.prototype.toString.call(dom) !== '[object Object]' &&
              dom
            ) {
              //这里是针对遍历的情况（多个输入框），取值为数组
              dom = dom[0];
            }
            if (!dom) {
              dom = document.querySelector(`#${i.replace('.', '-')}`);
              if (!dom) continue;
              dom.scrollIntoView({
                block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
              });
              break;
            } else {
              if (!dom) continue;
              dom.$el.scrollIntoView({
                block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
              });
              break;
            }
          }
        }
      });
    },
    reset() {
      this.$emit('reset');
    },
    resetParam(formKey, key) {
      if (!this.windfarmData) return;
      this.formData[formKey] = this.windfarmData[key];
    }
  }
};
</script>
<style lang="less" scoped>
.fin-form {
  position: relative;

  .fin-form-header {
    padding: 1px 16px;
    display: flex;
    font-size: 16px;
    line-height: 30px;
    height: 30px;
  }

  /deep/.el-collapse-item__header {
    background: #c8e0f5;
  }

  &.empty-form {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(50%);
    font-size: 14px;
    color: #8f9197;
    height: auto;
  }

  /deep/.el-form-item {
    .el-form-item__label {
      text-align: right;
      width: 230px;
    }

    .el-form-item__content {
      min-width: 200px;
    }
  }

  /deep/.el-collapse {
    .el-input-group__append {
      border: none;
      border-bottom: 1px solid #fff;
    }

    .el-collapse-item__header,
    .el-collapse-item__wrap {
      padding-left: 16px;
    }

    .el-collapse-item__header {
      height: 30px;
    }

    .el-collapse-item__content {
      .el-form-item {
        width: 48%;
      }
    }
  }

  /deep/.data-select {
    .el-select {
      width: auto;
    }
  }

  /deep/.el-select {
    .el-input {
      &.is-disabled {
        .el-input__inner {
          background-color: #fff;
          border-color: #fff;
          color: #000;
          cursor: default;
        }

        .el-input__icon {
          cursor: default;
        }
      }
    }
  }

  .bottom-tool {
    text-align: center;
    padding-top: 20px;
    background: #fff;
  }
}
</style>
